export const FETCH_SITE_ITEM = 'FETCH_SITE_ITEM'
export const SET_SITE_ITEM = 'SET_SITE_ITEM'

export function fetchSiteItem (urlParam) {
  return async function (dispatch) {

  }
}

export function setSiteItem (siteItem) {
  return {
    type: SET_SITE_ITEM,
    siteItem
  }
}
